import { translator } from 'core/localization';
import { AntSelectOption } from 'controls/react/ant/ant-select/types';

const i18n = translator({
	'Number Ordering': {
		no: 'Tall rekkefolge',
	},
	'Flow': {
		no: 'Flyt',
	},
});

export enum AdaptiveAlgorithm {
	Ordered = 'orderd',
	Flow = 'flow',
}

let adaptiveAlgorithmDataSource: AntSelectOption[];

export function getAdaptiveAlgorithmDataSource() {
	if (adaptiveAlgorithmDataSource == null) {
		adaptiveAlgorithmDataSource = [
			{
				value: AdaptiveAlgorithm.Flow,
				label: i18n('Flow'),
			},
			{
				value: AdaptiveAlgorithm.Ordered,
				label: i18n('Number Ordering'),
			},
		];
	}
	return adaptiveAlgorithmDataSource;
}
